export default {
    GET_LIST_TIMEKEEPING: 'GET_LIST_TIMEKEEPING',
    GET_LIST_SUCCESS: 'GET_LIST_SUCCESS',
    GET_LIST_FAILE: 'GET_LIST_FAILE',
    SET_QUERY:'SET_QUERY'
};
